import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const SiteContext = createContext(null);

export const DEFAULT_COLORS = { accent: "#8A3A33", accentDark: "#702F29", blush: "#D9C5C1" };

const hexToTriplet = (hex) => {
  const m = hex.replace("#", "");
  return `${parseInt(m.slice(0, 2), 16)} ${parseInt(m.slice(2, 4), 16)} ${parseInt(m.slice(4, 6), 16)}`;
};

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);

  useEffect(() => {
    axios.get(`${API}/site`)
      .then((r) => setSite({ images: {}, colors: DEFAULT_COLORS, ...r.data }))
      .catch(() => setSite({ images: {}, colors: DEFAULT_COLORS }));
  }, []);

  useEffect(() => {
    if (!site?.colors) return;
    const root = document.documentElement;
    const c = { ...DEFAULT_COLORS, ...site.colors };
    root.style.setProperty("--c-rouge", hexToTriplet(c.accent));
    root.style.setProperty("--c-rouge-dark", hexToTriplet(c.accentDark));
    root.style.setProperty("--c-blush", hexToTriplet(c.blush));
  }, [site]);

  const img = (key, fallback) => {
    const src = site?.images?.[key] || fallback;
    return src && src.startsWith("/api/") ? `${BACKEND}${src}` : src;
  };

  return <SiteContext.Provider value={{ site, setSite, img }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
